<template>
	<app-section>
		<app-title :title="`Welcome ${user.name}`" />
	</app-section>
</template>

<script>
	import AppSection from '@/components/app/AppSection';
	import { mapGetters } from 'vuex';

	export default {
		name: 'Home',
		components: {
			AppSection,
		},
		data: () => ({
			nr: null,
		}),
		computed: {
			...mapGetters({
				user: 'user',
			}),
		},
	};
</script>
